<template>
	<div v-if="firstProduct && visitedHypermarketInstance" class="flex gap-4 lg:gap-10">
		<div class="flex flex-col items-center">
			<span class="text-heading-quaternary font-bold [writing-mode:vertical-rl] rotate-180 whitespace-nowrap">
				Výhodné menu
			</span>
			<div class="w-px bg-border-secondary flex-1 mt-4" />
		</div>
		<AbsoluteInternalLink :to="{name: 'branch-online-objednavka-slug', params: {branch: visitedHypermarketInstance.slug, slug: 'restaurace'}}">
			<GOOSProductTile
				class="h-full bg-white"
				:product="firstProduct"
				is-static
				is-menu-tile
			/>
		</AbsoluteInternalLink>
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
	import {useGoosGastroStore} from '~/stores/goos/gastro';
	import {ProductionTypeIdEnum} from '~/stores/shoppingCart';
	import {PREFERRED_MENU_MEALTYPE_ID, RESTAURANT_MEAL_PRESENTATION_FRONTEND_ID} from '#shared/constants';
	import useBranchPageAvailability from '~/composables/useBranchPageAvailability';

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket} = storeToRefs(hypermarketsStore);
	const {visitedHypermarketInstance} = useVisitedHypermarket();
	const visitedBranchSlug = computed(() => visitedHypermarketInstance.value?.slug ?? null);
	const {data: branchPageAvailability, loading: branchPageAvailabilityLoading} = useBranchPageAvailability(visitedBranchSlug);

	const goosGastroStore = useGoosGastroStore();

	const {data: gastroProducts} = await useAsyncData(
		`RestaurantMenuTile-${visitedHypermarketInstance.value?.content?.gsoaId || 'globus'}`,
		async () => {
			if (!visitedHypermarketInstance.value || branchPageAvailabilityLoading.value || !branchPageAvailability.value.hasRestaurant) {
				return null;
			}

			return await goosGastroStore.fetchOffers({
				localityId: Number(visitedHypermarketInstance.value.content.gsoaId),
				productTypeId: ProductionTypeIdEnum.RESTAURANT,
				offset: 0,
				limit: 1,
				frontendId: RESTAURANT_MEAL_PRESENTATION_FRONTEND_ID,
				onlyOrderableNow: false,
				onlyOrderableToday: true,
				tags: [String(PREFERRED_MENU_MEALTYPE_ID)],
			}).catch(() => null);
		},
		{watch: [selectedHypermarket, branchPageAvailability, branchPageAvailabilityLoading]},
	);

	const firstProduct = computed(() => gastroProducts.value?.result?.[0]);
</script>
